import "reflect-metadata";
import { Container } from "inversify";

const iocContainer = new Container();

export { iocContainer };

